module.exports = __webpack_public_path__ + "static/derjenige-der-nicht-weiß-zu-lieben-kampft-03-b715850d0a0e50b5c002ce496449690c.jpg";